<template>
  <div class="alert table-bar text-dark" role="alert">
    <div class="row">
      <div class="col-sm-6">
        <p v-if="count && count > 0" class="pagination-results">Showing {{ skip + 1 }} to {{ lastIndex }} of {{ count }} results</p>
      </div>
      <div class="col-sm-6 text-right">
        <p class="per-page-display">
          <span>Show </span>
          <v-select v-model="selected" :options="perPageOptions" @input="changedPerPage" class="select-control" :clearable="false" />
          <span>per page</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config';

export default {
  name: 'PaginationDisplay',
  props: {
    skip: Number,
    lastIndex: Number,
    count: Number,
    perPage: Number
  },
  data() {
    return {
      selected: '',
      perPageOptions: [config.DEFAULT_PER_PAGE, 20, 50, 100]
    }
  },
  created() {
    this.selected = this.perPage || config.DEFAULT_PER_PAGE;
  },
  methods: {
    changedPerPage() {
      this.$emit('updatePerPage', this.selected);
    }
  }
}
</script>

<style>
.per-page-display {
  display: flex;
  justify-content: flex-end;
}

.per-page-display span {
  margin: 10px 6px 0px 6px;
}

.per-page-display .v-select {
  min-width: 100px;
}
</style>
